import React, {useState, useEffect} from 'react'
import './SuccessPage.scss'
import {useSelector} from 'react-redux'
import {Spinner} from 'react-bootstrap'
import {SuccessPageProps} from '../type'
import {useI18n} from '../../../../Utils/_helpers/useI18n'

const SuccessPage: React.FC<SuccessPageProps> = ({dataShareContact, onClose, name}) => {
  const [isInitialLoading, setIsInitialLoading] = useState(true)
  const isLoading = useSelector((state: any) => state.loading.isLoading)
  const {t} = useI18n()

  const contactDetailsConfig = [
    {field: 'phone', icon: 'telephone-fill'},
    {field: 'email', icon: 'envelope-fill'},
    {field: 'jobTitle', icon: 'briefcase-fill'},
    {field: 'companyName', icon: 'building'},
    {field: 'website', icon: 'globe'},
    {field: 'address', icon: 'geo-alt-fill'},
  ] // TODO: add more fields

  useEffect(() => {
    const loadInitialData = async () => {
      try {
        setIsInitialLoading(true)
        await new Promise((resolve) => setTimeout(resolve, 300))
      } finally {
        setIsInitialLoading(false)
      }
    }

    loadInitialData()
  }, [])

  if (isInitialLoading) {
    return (
      <div className='success-page-container d-flex justify-content-center align-items-center'>
        <div className='text-center'>
          <Spinner animation='border' role='status' className='mb-2' />
          <p>{t('WALLET_CARD.SUCCESS_PAGE.LOADING_CONNECTION')}</p>
        </div>
      </div>
    )
  }

  return (
    <div className='success-page-container'>
      <div className='success-message d-flex align-items-center justify-content-center gap-2 flex-column'>
        <div className='icon fs-2'>🎉🎉</div>
        <p className='text-connect-success p-0 m-0 fs-1'>
          {t('WALLET_CARD.SUCCESS_PAGE.CONNECTED_WITH')}
          <br />
          {name}
        </p>
      </div>

      <div className='card-preview-success'>
        <div className='card-preview-inner'>
          <div className='card-body'>
            <div className='card-info'>
              <h1>{t('WALLET_CARD.SUCCESS_PAGE.TITLE')}</h1>
              <h3 className='text-truncate-1'>{dataShareContact.fullName}</h3>

              {contactDetailsConfig.map((item) => {
                const value = dataShareContact[item.field as keyof typeof dataShareContact]
                if (value) {
                  return (
                    <div key={item.field} className='contact-detail fs-3'>
                      <i className={`bi bi-${item.icon} fs-4`}></i>
                      <span>{String(value)}</span>
                    </div>
                  )
                }
                return null
              })}
            </div>
          </div>
        </div>
      </div>

      <div className='confetti'>
        {Array(13)
          .fill('')
          .map((_, i: number) => (
            <div key={i} className='confetti-piece'></div>
          ))}
      </div>
      <h3 className='text-center text-view-card-description'>{t('WALLET_CARD.SUCCESS_PAGE.VIEW_CARD_DESCRIPTION', {name: name})}</h3>

      <div className='d-flex flex-column align-items-center mt-3 gap-2'>
        {onClose && (
          <button className='close-button mt-2' onClick={onClose} disabled={isLoading}>
            {t('WALLET_CARD.SUCCESS_PAGE.VIEW_CARD')}
          </button>
        )}
      </div>
    </div>
  )
}

export default SuccessPage
